import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { ReactComponent as Play } from '../../icons/play-solid.svg';

const ViewServiceBtn = ({ onViewService, service }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="view-service-control"
      aria-label={t('services.play')}
      onClick={() => onViewService(service)}
    >
      <Icon className="solid play-icon" icon={<Play />} />
    </button>
  );
};

export default ViewServiceBtn;
